import gql from 'graphql-tag';

export const GET_JOB_METRIC = gql`
  query ($ownedBy: JobOwnerEnum) {
    weployer {
      jobMetric(ownedBy: $ownedBy) {
        activeJobsCount
        activeWeployeesCount
        timesheetsToApproveCount
      }
    }
  }
`;

export const GET_ACTIVE_AND_UPCOMING_POSITIONS = gql`
  query ($ownedBy: JobOwnerEnum) {
    weployer{
      activeAndUpcomingPositions(ownedBy: $ownedBy) {
        id
        jobId
        weployeeName
        weployeeInitials
        weployeeProfileImageUrl
        startTime
        finishTime
        extendable
        isFinishingSoon
      }
    }
  }
`;

export const dashboardJobsQueryParams = ({ statuses, ownedBy }) => ({ statuses, ownedBy });

export const GET_NOTIFICATIONS = gql`
  query ($maxItems: Int!, $categories: [NotificationCategoryEnum!], $dismissed: Boolean) {
    weployer{
      notifications(maxItems: $maxItems, categories: $categories, dismissed: $dismissed) {
        isActionedByCurrentUser
        id
        title
        category
        type
        organisationId
        metadata
        positionId
        weployee {
          id
          contactDetails {
            email
            name
            phoneNumber
          }
          profileImageUrl
        }
        createdAt
        actionedBy
        actionedAt
        canAction
      }
    }
  }
`;

export const dashboardNotificationsQueryParams = ({ maxItems, categories, dismissed }) => ({ maxItems, categories, dismissed });

export const DISMISS_NOTIFICATION_MUTATION = gql`
  mutation dismissNotification($notificationId: ID!) {
    weployer {
      dismissNotification (notificationId: $notificationId) {
        notificationId
      }
    }
  }
`;

export const dashboardMutationParams = ({ notificationId }) => ({ notificationId });

export const ACTION_NOTIFICATION_MUTATION = gql`
  mutation actionNotification($notificationId: ID!) {
    weployer {
      actionNotification(notificationId: $notificationId) {
        notificationId
      }
    }
  }
`;
